module.exports = __webpack_public_path__ + "media/images/operation_jobs/icon_dryer-801ba9a73330fa9163ef3e5bd15a995d.png";